import DOMPurify from "dompurify";
import { Check, ExternalLink, Phone } from "lucide-react";
import { useWizardContext } from "./shared";
import { Button } from "@/components/ui/button";

export function ArrivalScreen() {
  const { state } = useWizardContext();
  const { property, settings } = state.payload!;
  const html = settings.arrivalInstructionsHtml ? DOMPurify.sanitize(settings.arrivalInstructionsHtml) : null;

  return (
    <div>
      <div className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-800">
        <Check className="h-3.5 w-3.5" strokeWidth={3} />
        Pre-check-in complete
      </div>

      <h1 className="screen-h1">Arrival info</h1>
      <p className="screen-p mt-2">Everything you need for the day you arrive.</p>

      {html ? (
        <div
          className="prose prose-sm mt-5 rounded-xl border bg-card p-4 text-sm text-slate-700"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (
        <div className="mt-5 rounded-xl border bg-muted/40 p-4 text-sm text-slate-600">
          {property.phone
            ? <>Reception will guide you on arrival — call us on <a className="font-medium text-primary" href={`tel:${property.phone.replace(/\s+/g, "")}`}>{property.phone}</a> if you need anything before then.</>
            : "Reception will guide you on arrival. Check your booking confirmation if you need to reach us before then."}
        </div>
      )}

      {property.hotelAppUrl && (
        <Button asChild className="mt-5 w-full h-11">
          <a href={property.hotelAppUrl} target="_blank" rel="noreferrer">
            <ExternalLink className="h-4 w-4" />
            Open {property.name} guest app
          </a>
        </Button>
      )}

      {property.phone && (
        <Button asChild variant="outline" className="mt-3 w-full h-11">
          <a href={`tel:${property.phone.replace(/\s+/g, "")}`}>
            <Phone className="h-4 w-4" />
            Call the property: {property.phone}
          </a>
        </Button>
      )}

      <p className="mt-6 text-xs text-muted-foreground">
        This page stays available from your check-in link until 24 hours after arrival.
      </p>
    </div>
  );
}
